import URLS from "@api/constants/urls";
import { handleGlobalGetRequestQuery } from "@api/functions/getRequests";

const getBrokerFrontendBootAPI = ({ signal }: { signal?: AbortSignal }) =>
  handleGlobalGetRequestQuery({
    url: URLS.FRONTEND_BOOT,
    signal,
  });

export { getBrokerFrontendBootAPI };
